import { format, parseISO, isValid } from "date-fns";

export function formatDateToISOString(dateInput) {
  const date = new Date(dateInput);

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");

  // Simulate 5-digit fractional seconds by padding milliseconds
  const millis = String(date.getUTCMilliseconds()).padStart(3, "0") + "00";

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${millis}Z`;
}

export const formatDate = (isoString) => {
  if (!isoString) return "";

  const d =
    typeof isoString === "string" ? parseISO(isoString) : new Date(isoString);

  if (!isValid(d)) return "";

  return format(d, "dd, MMM yyyy");
};

export const formatAmount = (amount) => {
  if (typeof amount === "string") {
    amount = parseFloat(amount);
  }

  if (isNaN(amount)) {
    return "0.00";
  }

  // const options = {
  //   style: 'currency',
  //   currency: 'NGN',
  //   minimumFractionDigits: precision
  // };
  const options = {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
  };

  return new Intl.NumberFormat("en-UK", options).format(amount);
};

export const formatNumber = (figure, precision) => {
  if (typeof figure === "string") {
    figure = parseFloat(figure);
  }

  if (isNaN(figure)) {
    return "0.00";
  }

  return new Intl.NumberFormat(
    "en-UK",
    precision ? { minimumFractionDigits: precision } : {}
  ).format(figure);
};
